export default __webpack_public_path__ + "static/media/aqua8.a103be2e.png";